import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./technikStyle.css";
import "aos/dist/aos.css";
import AOS from "aos";

export default function Technik() {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "DJ - EMAN"

        AOS.init({
            duration: 1000,
            once: false
        });
    }, []);

    return (
        <div className="technikContainer">
            <h1>Technik</h1>
            <h2>Jede Veranstalltung läuft nur mit guter und zuverlässiger Technik. Deswegen setzten wir auf die neuste Licht- und Tontechnik und auf Markenprodukte wie Sennheiser, Pioneer, the box pro, Stairville, Varytec, Botex, Daslight und MA Lighting um einen Reibungslosen Produktionsablauf zu gewährleisten. Ob kleines Fest im Familienkreis oder Großveranstaltung mit bis zu 2.000 Gästen, wir sorgen für die passende Ausstattung und ein unvergessliches Event-Erlebnis.</h2>
{/*             <div className="logoContainer">
                <img src="/img/sennheiser.png" />
                <img src="/img/thebox.png" />
                <img src="/img/pioneer.png" />
                <img src="/img/botex.png" />
                <img src="/img/daslight.png" />
                <img src="/img/stairville.png" />
                <img src="/img/varytec.png" />
            </div> */}
            <div className="iconsContainer">
                <div data-aos="fade-right" className="iconContainer">
                    <img src="/img/volume.svg" />
                    <h1>Tinnitus Schutz</h1>
                    <h2>Wir prüfen in Regelmäßigen Abständen die Räumliche Lautstärke, um die Rechtlichen Vorgaben einzuhalten und Sie vor einem Tinnitus zu schützen</h2>
                </div>
                <div data-aos="fade-in" className="iconContainer">
                    <img src="/img/check.svg" />
                    <h1>CE-Kennzeichnung</h1>
                    <h2>Alle unsere Geräte besitzen eine CE-Kennzeichnung und erfüllen somit die Europäischen Sicherheitsvorgaben</h2>
                </div>
                <div data-aos="fade-left" className="iconContainer">
                    <img src="/img/weight.svg" />
                    <h1>Last Sicherheit</h1>
                    <h2>Schwere Lasten welche über den Köpfen von Besuchern oder Künstlern hängen, werden doppelt gesichert</h2>
                </div>
            </div>
            <hr/>
            <img src="/img/wurlitz.webp" />
            <p><u>Wurlitzer Kärwa</u></p>
            <p>Festzelte lassen sich mit moderner Ton- und Lichttechnik ausstatten um für die passende Stimmung und beste Klangqualität zu sorgen</p>
            <img src="/img/silentparty.webp" />
            <p><u>Schwarzenbacher Silent Party</u></p>
            <p>Außergewöhnliche Eventformate wie Kopfhörerpartys lassen sich durch gezielte Ambientebeleuchtung eindrucksvoll in Szene setzen</p>
            <img src="/img/freiheitshalle.jpeg" />
            <p><u>Freiheitshalle Hof</u></p>
            <p>Pyrotechnik kann auf Wunsch bei größeren Events oder besonderen Anlässen wie Hochzeiten bereitgestellt und professionell umgesetzt werden</p>
            <img src="/img/limbach.jpeg" />
            <p><u>Trucker Festival Limbach</u></p>
            <p>Bands können individuell mit professioneller Licht- und Tontechnik ausgestattet werden, um ein eindrucksvolles Live-Erlebnis zu schaffen</p>
            <br />
            <h4>--- Wichtig ---</h4>
            <p>Für größere Veranstaltungen muss ein FOH Platz aufgebaut werden. Dieser Ort ist für unsere Techniker welche die Licht- und Tontechnik betreuen und optimal auf die Tanzfläche und die Räumlichkeit abstimmen.</p>
            <img src="/img/foh.png" />
        </div>
    )
}
